module.exports = __webpack_public_path__ + "static/media/motorolaG8PowerLite.132dd703.jpeg";